import {Parser} from 'htmlparser2';

const underlineHtml = state => {
  let max, pos = state.pos;

  max = state.posMax;
  if (state.src.slice(pos + 1, pos + 2).toLowerCase() !== 'u') {
    return false;
  }

  const underline = {
    start: null,
    end: null,
  };

  const parser = new Parser({
    onopentag(name, attributes, isImplied) {
      if (name === 'u') {
        if (!underline.start) {
          underline.start = {
            startIndex: parser.startIndex,
            endIndex: parser.endIndex,
          };
        }
      }
    },
    onclosetag(name, isImplied) {
      if (name === 'u') {
        if (!underline.end) {
          underline.end = {
            startIndex: parser.startIndex,
            endIndex: parser.endIndex,
          };
        }
      }
    },
  });

  parser.write(state.src.slice(pos));

  if ((!underline.start || underline.start.startIndex > 0) || !underline.end) {
    return false;
  }

  state.push('underline_open', 'u', 1);

  state.pos = pos + underline.start.endIndex + 1;
  state.posMax = pos + underline.end.startIndex;

  state.md.inline.tokenize(state);

  state.push('underline_close', 'u', -1);

  state.pos = pos + underline.end.endIndex + 1;
  state.posMax = max;

  return true;
};

export const markdownUnderline = md => md.inline.ruler.before('link',
    'underline', underlineHtml);